export default __webpack_public_path__ + "static/media/journal-blue-icon.fa65a096.svg";